import React from "react";
import FluidImage from "../../../components/fluidImage";
import { render } from "storyblok-rich-text-react-renderer";
import rteResolver from "../../../utils/rteResolver";

const NumberedCopyImage = (props) => {
    const blok = props.blok


    const padding = blok.padding != undefined && blok.padding != "" ? blok.padding : "large-top"

    const hasNumber = blok.number != undefined && blok.number != ""
    const hasTitle = blok.title != undefined && blok.title != ""

    return (
        <section className={`width grid lg:grid-cols-12 lg:gap-20 ${padding == "large-top" && `pt-8 lg:pt-32`}`}>

            {
                (hasNumber || hasTitle) && (
                    <div className="lg:hidden pb-8 space-y-2" aria-hidden="true">

                        <h2 className="font-semibold text-2xl !mt-0 !mb-0">
                            <span>{blok.number} </span>{blok.title}
                        </h2>
                        <span className="unpad-first unpad-last rte block">{blok.tagline != undefined && render(blok.tagline, rteResolver)}</span>
                    </div>
                )
            }

            <div className={`lg:col-span-5 ${blok.reverse_on_desktop ? `${hasNumber ? `lg:mr-14` : ``}` : `${hasNumber ? `lg:ml-14` : ``}`}`}>
                <FluidImage image={blok.image} />
            </div>
            <div className={`lg:col-span-7 flex flex-col lg:flex-row ${blok.number == `` ? `items-center` : `items-start`} justify-start max-w-2xl lg:space-x-14 ${blok.reverse_on_desktop ? `lg:order-first ${hasNumber ? `lg:ml-14` : ``}` : `${hasNumber ? `lg:mr-14` : ``}`}`}>

                {hasNumber && (
                    <span className={`text-53 font-extralight font-serif ${blok.number == `` ? `hidden` : ``} mobile:hidden`}>
                        {blok.number}
                    </span>

                )}
                <div>
                    {blok.title != "" && (
                        <h2 className="font-semibold text-2xl mobile:hidden !mt-0">
                            {blok.title}
                        </h2>

                    )}
                    <div className={`rte ${blok.title == "" ? `unpad-first` : ``} unpad-last text-lg lg:pr-8`}>
                        <span className="mobile:hidden rte">{blok.tagline != undefined && render(blok.tagline, rteResolver)}</span>
                        {render(blok.copy, rteResolver)}
                    </div>
                </div>

            </div>


        </section>
    )
}

export default NumberedCopyImage